import React from "react";
import "./styles.scss";
import { Country } from "../../../../shared/constants/Constant";
import logoMalaysia from "../../../../shared/resources/Malaysia_logo_white_2021.png";
import logoSrilanka from "../../../../shared/resources/insl-logo-white-transparent.png";
import logoBosnia from "../../../../shared/resources/ieee-logo-bih-white.png";
import logoJamaica from "../../../../shared/resources/Jamaika-White-Flat.png";
import logoIndia from "../../../../shared/resources/india-logo.png";
import logoIndonesia from "../../../../shared/resources/Indonesia logo white-01.png";

interface IProps {
  country: Country;
}

const HeaderMobile = (props: IProps) => {
  const getImage = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return (
          <img
            src={logoSrilanka}
            alt=""
            style={{
              width: "100px",
              marginTop: "5px",
            }}
          />
        );
      case Country.MALAYSIA:
        return (
          <img
            src={logoMalaysia}
            alt=""
            style={{
              width: "180px",
            }}
          />
        );
      case Country.JAMAICA:
        return (
          <img
            src={logoJamaica}
            alt=""
            style={{
              width: "180px",
            }}
          />
        );
      case Country.INDIA:
        return (
          <img
            src={logoIndia}
            alt=""
            style={{
              width: "180px",
            }}
          />
        );
      case Country.INDONESIA:
        return (
          <img
            src={logoIndonesia}
            alt=""
            style={{
              width: "180px",
            }}
          />
        );
      default:
        return (
          <img
            src={logoBosnia}
            alt=""
            style={{
              width: "120px",
            }}
          />
        );
    }
  };
  const getTitle = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>
              IEEE Innovation Nation Sri Lanka 2020
            </h1>
            <h2 style={{ fontSize: "15px" }}>Pre-Accelerator</h2>
          </>
        );
      case Country.INDIA:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>IEEE Innovation Nation India</h1>
            {/* <h2 style={{ fontSize: "15px" }}>Pre-Accelerator</h2> */}
          </>
        );
      case Country.MALAYSIA:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>
              IEEE Innovation Nation Malaysia 2020
            </h1>
            <h2 style={{ fontSize: "15px" }}>Techno-preneurship Bootcamp</h2>
          </>
        );
      case Country.INDONESIA:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>
              IEEE Innovation Nation Indonesia 2021
            </h1>
            <h2 style={{ fontSize: "15px" }}>Techno-preneurship Bootcamp</h2>
          </>
        );
      case Country.JAMAICA:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>
              IEEE Innovation Nation Jamaica 2020
            </h1>
          </>
        );
      default:
        return (
          <>
            <h1 style={{ fontSize: "20px" }}>
              IEEE Innovation Nation Bosnia & Herzegovina
            </h1>
          </>
        );
    }
  };
  return (
    <div className="header-mobile-wrapper">
      {getImage()}
      {getTitle()}
    </div>
  );
};

export default HeaderMobile;
